import dynamic from 'next/dynamic';
import { ScriptSpotProps } from './script-spot';

export const ScriptSpot = dynamic<ScriptSpotProps>(() => import('./script-spot').then((mod) => mod.ScriptSpot), {
    ssr: false,
});
